export const getAccessToken = () => process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
